// @todo: effort minimal sur ce mapper, du fait que le Content Model est voué à disparaître au profit de Common Item.

import { ContentModelId } from '../../../../../types/ContentModelId'
import type { FaqBlock } from '../../../../faq-block/domain/FaqBlock'
import type { FaqList } from '../../../domain/FaqList'
import type { FaqListDTO } from '../../../domain/FaqListDTO'
import type { PartnerId } from '../../../../../types/PartnerId'
import type { SkinVariant } from '../../../../../types/SkinVariant'

import { isAvailablePartner } from '../../../../../utils/filter-by-partner'
import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'
import { mapEntryDTOList } from '../../../../../utils/map-entry-dto-list'

export const mapFaqListFromApi = (dto: FaqListDTO, partnerId?: PartnerId): FaqList | undefined => {
  if (!(isNonNullableEntryDTO(dto) && isAvailablePartner(partnerId, dto.fields.partnerFilter))) {
    return undefined
  }

  const { anchorLabel, backgroundColor, qa, richTitle: title } = dto.fields

  const children = mapEntryDTOList<FaqBlock>(qa)

  return {
    anchorLabel,
    children,
    contentType: ContentModelId.FAQ_LIST,
    skinVariant: backgroundColor?.replace('-color', '') as SkinVariant,
    title,
  }
}
